









import { Vue, Component, Prop } from "vue-property-decorator";

import ClusterBar from "../components/ClusterBar.vue";
import { ProductInstanceResult } from "@futuri/cloudsso-client/src/client/types/productInstances";
import { Getter } from "vuex-class";
import { ProductType } from "@futuri/cloudsso-client/src/client/types/productType";

@Component({
  components: {
    ClusterBar
  }
})
export default class ProductLayout extends Vue {
  @Prop()
  productType?: ProductType;

  @Getter("availableInstances")
  availableInstances?: ProductInstanceResult[];

  get instances() {
    console.log("get product instances");

    const currentProduct = this.productType;
    const instances = this.availableInstances ?? [];

    const productInstances = instances.filter(
      inst => inst.product === currentProduct
    );
    return productInstances;
  }
}
